import React from 'react';
import { ModalTopNavigation } from '@adc/parallax-component-library';
import { IconBack, IconClose } from '@adc/parallax-icons';
import mediator from 'Utilities/mediator';
const InAppActionBar = ({ testID, title, closeBtn, onBack }) => {
    return (React.createElement(ModalTopNavigation, { title: title, testID: testID, maxLinesOfTitle: 1, buttonStart: {
            element: closeBtn ? (React.createElement(IconClose, { testID: `${testID}.close-btn-icon` })) : (React.createElement(IconBack, { testID: `${testID}.back-btn-icon` })),
            label: 'close',
            onPress: onBack ? onBack : () => mediator.publish('router:back'),
        } }));
};
export { InAppActionBar };
